import { ValueOf } from '@home-diy-toolbox/web/common-types';

export const PHONE_DAMAGE_SEVERITY = {
	Hazardous: 'hazardous_damage', // Break early for hazard page
	NonHazardous: 'non-hazardous', // Refer to answer tags for 'not_covered' tags
	None: 'none', // No damage at all, no check necessary
} as const;

export type PhoneDamageSeverity = ValueOf<typeof PHONE_DAMAGE_SEVERITY>;
